import { ComponentIds, ReplaceUtils, } from "@inter-ikea-core/core";
import EntityIsReplacingComponent from "../components/EntityIsReplacingComponent";
import { LEFT } from "../constants";
import { getEntityProductRef } from "../utils/entityUtils";
import { bothEntitySidesAreAttached, getEntityAttachments, } from "./attachedTo";
export const getComponentSize = (_entity) => {
    const sizeComponent = _entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
    if (!sizeComponent)
        throw new Error("Entity does not have a communication size component.");
    return sizeComponent.size;
};
export const getShortestEntity = (_entity1, _entity2) => getComponentSize(_entity1).height < getComponentSize(_entity2).height
    ? _entity1
    : _entity2;
export const entitiesAreEqualDepth = (_entity, _entityPlacementSide) => {
    const { left, right } = getEntityAttachments(_entity);
    const entityDepth = getComponentSize(_entity).depth;
    if (_entityPlacementSide === LEFT) {
        const entityRightDepth = right && getComponentSize(right).depth;
        return entityDepth === entityRightDepth;
    }
    const entityLeftDepth = left && getComponentSize(left).depth;
    return entityDepth === entityLeftDepth;
};
export const entitiesAreEqualHeight = (entity1, entity2) => {
    const entity1Height = getComponentSize(entity1).height;
    const entity2Height = getComponentSize(entity2).height;
    return entity1Height === entity2Height;
};
export const extractWidthFromProductRef = (entity) => {
    const width = getEntityProductRef(entity).split("x")[2];
    if (!width || !width.length)
        throw new Error("Width could not be extracted from product ref. Very worrying..");
    return width;
};
export const getSplitProductRef = (entity) => {
    const entityProductRef = getEntityProductRef(entity);
    const [type, dimensions] = entityProductRef.split("-");
    const [height, depth, width] = dimensions.split("x");
    return { type, height, depth, width };
};
export const replacer = (origin, replacement) => replacement || origin;
export const partiallyReplaceProductRef = (originalEntity, { type: ot, height: oh, depth: od, width: ow }) => {
    const { type: t, height: h, depth: d, width: w, } = getSplitProductRef(originalEntity);
    return `${replacer(t, ot)}-${replacer(h, oh)}x${replacer(d, od)}x${replacer(w, ow)}`;
};
export const getProductRef = (previousEntity, neighbourEntity) => {
    const { height } = getSplitProductRef(neighbourEntity);
    return partiallyReplaceProductRef(previousEntity, { height });
};
export const shouldReplaceSection = (_entity) => {
    const generateReturn = (shouldReplace, withProductRef) => ({
        shouldReplace,
        withProductRef,
    });
    const bothSidesOfEntityIsAttached = bothEntitySidesAreAttached(_entity);
    if (!bothSidesOfEntityIsAttached)
        return generateReturn(false, "");
    const height = getComponentSize(_entity).height;
    const { left, right } = getEntityAttachments(_entity);
    if (!left || !right)
        throw new Error("Entity didn't have two neighbours when expected to.");
    const shortestNeighbour = getShortestEntity(left, right);
    const neighbourIsTaller = getComponentSize(shortestNeighbour).height > height;
    return generateReturn(neighbourIsTaller, getProductRef(_entity, shortestNeighbour));
};
export const replaceEntity = (_entity, _productRef, _componentsList, _productManager, _coreServices) => {
    const newEntity = createReplacementEntity(_productRef, _productManager);
    copyNecessaryComponents(newEntity, _componentsList);
    newEntity.addComponent(new EntityIsReplacingComponent(_entity));
    ReplaceUtils.replaceEntity(_entity, newEntity, 0, _coreServices);
    return newEntity;
};
const createReplacementEntity = (_productRef, _productManager) => {
    const newEntity = _productManager.createEntity(_productRef);
    if (!newEntity)
        throw new Error("A new entity could not be created.");
    return newEntity;
};
export const copyNecessaryComponents = (_newEntity, _componentsList) => {
    _componentsList.forEach((component) => _newEntity.addComponent(component));
    return _newEntity;
};
